import Auth, {ACCESS_TOKEN_COOKIE_NAME} from './Auth';
import API from './API';
import AnnouncementApi from './api/Announcement';
import ChallengeCodeApi from './api/ChallengeCode';
import ChallengeLockApi from './api/ChallengeLock';
import ChallengeVersionApi from './api/ChallengeVersion';
import ChallengeEntityApi from './api/ChallengeEntity';
import CurriculumApi from './api/Curriculum';
import DistrictApi from './api/District';
import LessonApi from './api/Lesson';
import PracticeApi from './api/Practice';
import MsCognitoServiceApi from './api/MsCognitoService';
import PAMApi from './api/PAM';
import PollApi from './api/Poll';
import QuestionApi from './api/Question';
import RubricApi from './api/Rubric';
import SAMApi from './api/SAM';
import SchoolApi from './api/School';
import SettingApi from './api/Setting';
import StandardApi from './api/Standard';
import StatisticApi from './api/Statistic';
import StreamApi from './api/Stream';
import SubscriptionApi from './api/Subscription';
import UserApi from './api/User';
import WowMomentApi from './api/WowMoment'

import Cookie from './Cookie';
import BasicLayout from './react/layout/BasicLayout';
import FullLayout from './react/layout/FullLayout';
import ListPage from './react/layout/ListPage';
import Logo from './react/layout/Logo';
import Header from './react/layout/Header';
import Footer from './react/layout/Footer';
import Loader from './react/layout/Loader';
import StackedLoader, {
    LoaderMiddleware,
    LoadUpAction,
    LoadDownAction,
    LoadResetAction,
    LoadMessageAction,
    LOADUP,
    LOADDOWN,
    LOADRESET,
    LOADER_MESSAGE,
    loader,
    loader_message
} from './react/components/StackedLoader';

import Autocomplete from './react/components/Autocomplete';
import AutocompleteMultiple from './react/components/AutocompleteMultiple';
import Bouncing from './react/components/Bouncing';
import ChallengeDropdown from './react/components/ChallengeDropdown';
import Checkbox from './react/components/Checkbox';
import CustomDropdown from './react/components/CustomDropdown';
import ChallengeDropdownItem from './react/components/ChallengeDropdownItem';
import CustomToast from './react/components/CustomToast';
import DatePicker from './react/components/DatePicker';
import DateRangeSelector from './react/components/DateRangeSelector';
import DistrictDropdown from './react/components/DistrictDropdown';
import DownloadCSV from './react/components/DownloadCSV';
import ExportToGoogleDrive from './react/components/ExportToGoogleDrive';
import HTMLContent from './react/components/HTMLContent';
import LessonDropdown from './react/components/LessonDropdown';
import LessonDropdownItem from './react/components/LessonDropdownItem';
import LinearLoader from './react/components/LinearLoader';
import MultipleSelector from './react/components/MultipleSelector';
import OpenReaderSwitch from './react/components/OpenReaderSwitch';
import Paginator from './react/components/Paginator';
import PerPage from './react/components/PerPage';
import ProgressBar from './react/components/ProgressBar';
import QuickSearch from './react/components/QuickSearch';
import QuickSearchBar from './react/components/QuickSearchBar';
import SchoolDropdown from './react/components/SchoolDropdown';
import SchoolDropdownExtended from './react/components/SchoolDropdownExtended';
import SchoolDropdownItem from './react/components/SchoolDropdownItem';
import SearchResult from './react/components/SearchResult';
import Selector from './react/components/AnswerComponent/Selector';
import SimplePaginator from './react/components/SimplePaginator';
import Tabs from './react/components/Tabs';
import Toggle from './react/components/Toggle';
import UserDropdown from './react/components/UserDropdown';
import UserDropdownItem from './react/components/UserDropdownItem';
import Filters from './react/components/Filters';
import Sort from './react/components/Sort';
import {
    SuccessMessageAction,
    ErrorMessageAction,
    InfoMessageAction,
    WarningMessageAction
} from './react/components/CustomToast/actions';
import {ReloadListAction} from './react/layout/ListPage/actions'
import {setCurrentAction} from './react/components/Paginator/actions'
import {setLimitAction} from './react/components/PerPage/actions'
import {LoadingAction} from './react/layout/actions';
import {
    LoadAnnouncementsAction,
    LoadedAnnouncementsAction,
    LoadedAnnouncementsPagesAction,
    LoadedAnnouncementsTotalAction,
    LoadedAnnouncementsCurrentAction,
    LoadedAnnouncementsLimitAction,
    DeleteAnnouncementAction,
    MoveAnnouncementUpAction,
    MoveAnnouncementDownAction,
    LoadAnnouncementAction,
    SetAnnouncementAction,
    CreateAnnouncementAction,
    UpdateAnnouncementAction
} from './react/actions/announcement_actions';
import {
    LoadAnswersAction,
    LoadedAnswersAction,
    LoadedAnswersPagesAction,
    LoadedAnswersTotalAction,
    LoadedAnswersCurrentAction,
    LoadedAnswersLimitAction,
    LoadAnswerPointsAction,
    LoadedAnswerPointsAction,
    UpdateScoreAction
} from './react/actions/answer_actions';
import {
    LoadChallengeCodesAction,
    LoadChallengeVersionsAction,
    LoadedChallengeVersionsAction,
    LoadedChallengeVersionsPagesAction,
    LoadedChallengeVersionsTotalAction,
    LoadedChallengeVersionsCurrentAction,
    LoadedChallengeVersionsLimitAction,
    LoadChallengeCodeAction,
    LoadedChallengeCodeAction,
    ImportChallengeAction,
    ActivateChallengeAction,
    DisableChallengeAction,
    SoftUpdateAllChallengesAction,
    SoftUpdateChallengeContentAction,
    CheckUpdatesAction,
    LoadedChallengeUpdatesAction,
    IncreaseChallengeVersionAction,
    LoadChallengeVersionAction,
    LoadedChallengeVersionAction,
    LoadedChallengeCodesAction,
    LoadChallengeResourcesAction,
    LoadedChallengeResourcesAction,
    LoadChallengeVersionStreamEntitiesAction,
    LoadedChallengeVersionStreamEntitiesAction,
    SetChallengePreviewCurrentIndexAction,
    SetChallengePreviewShowReminderAction,
    CreateDistrictChallengeLockAction,
    LoadChallengeGuideAction,
    LoadMySchoolChallengesAction,
    LoadedMySchoolChallengesAction,
    SetLibrarySubjectAction,
    SetLibraryTopicAction,
    SetLibraryGradeAction,
    SetLibraryMeasureAction,
    SetLibraryThemeAction
} from './react/actions/challenge_actions';
import {
    LoadContractsAction,
    LoadedContractsAction,
    LoadedContractsPagesAction,
    LoadedContractsTotalAction,
    LoadedContractsCurrentAction,
    LoadedContractsLimitAction,
    LoadContractAction,
    SetContractAction,
    CreateContractAction,
    UpdateContractAction,
    ReviewContractAction,
    ApproveContractAction
} from './react/actions/contract_actions';
import {
    LoadCurriculaAction,
    LoadedCurriculaAction,
    LoadedCurriculaPagesAction,
    LoadedCurriculaTotalAction,
    LoadedCurriculaCurrentAction,
    LoadedCurriculaLimitAction,
    SyncCurriculaAction,
    LoadCurriculumAction,
    SetCurriculumAction,
    CreateCurriculumAction,
    UpdateCurriculumAction,
    LoadCurriculumByCodeAction,
    LoadCurriculumMapAction
} from './react/actions/curriculum_actions';
import {
    LoadDistrictsAction,
    LoadedDistrictsAction,
    LoadedDistrictsPagesAction,
    LoadedDistrictsTotalAction,
    LoadedDistrictsCurrentAction,
    LoadedDistrictsLimitAction,
    DeleteDistrictAction,
    LoadDistrictAction,
    SetDistrictAction,
    CreateDistrictAction,
    UpdateDistrictAction,
    DeleteSubscriptionAction,
    CreateSubscriptionAction,
    CreateDistrictChallengeLocksAction,
    DeleteChallengeLockAction,
    LoadDistrictChallengeLocksAction,
    LoadedDistrictChallengeLocksAction
} from './react/actions/district_actions';
import {
    LoadGradingProvidersAction,
    LoadedGradingProvidersAction,
    LoadedGradingProvidersPagesAction,
    LoadedGradingProvidersTotalAction,
    LoadedGradingProvidersCurrentAction,
    LoadedGradingProvidersLimitAction,
    LoadGradingProviderAction,
    SetGradingProviderAction,
    CreateGradingProviderAction,
    UpdateGradingProviderAction
} from './react/actions/grading_provider_actions';
import {
    LoadLessonsAction,
    LoadedLessonsAction,
    LoadedLessonsPagesAction,
    LoadedLessonsTotalAction,
    LoadedLessonsCurrentAction,
    LoadedLessonsLimitAction,
    LoadLessonAction,
    SetLessonAction,
    UpdateLessonAction,
    PauseLessonAction,
    UnpauseLessonAction,
    DeleteLessonAction,
    ScheduleForScoringAction,
    AssignUsersToLessonAction,
    LoadSchedulesAction,
    LoadedSchedulesAction,
    LoadedSchedulesPagesAction,
    LoadedSchedulesTotalAction,
    LoadedSchedulesCurrentAction,
    LoadedSchedulesLimitAction,
    DeleteScheduleAction,
    VerifyScheduleAction,
    VerifyGradesAction,
    CreateSchedulesAction,
    AssignGradesAction,
    AddClassCodesToSelectionAction,
    LoadedScheduleAction,
    LoadScheduleAction,
    UpdateScheduleAction,
    JoinLessonAction,
    JoinLessonForceAction,
    LoadPDCertificateAction,
    SetTeacherFacilitationShowStudentsAction,
    SetTeacherFacilitationSortByAction,
    SetTeacherFacilitationSelectedStreamIdAction,
    SetTeacherFacilitationSelectedCardIndexAction,
    SetTeacherFacilitationQuestionFullscreenAction,
    SetTeacherFacilitationMobileShowStreamsAction
} from './react/actions/lesson_actions';
import {
    LoadPollByQuestionIdAction,
    SetPollAction,
    LoadPollsAction,
    LoadedPollsAction
} from './react/actions/poll_actions';
import {
    LoadProjectsAction,
    LoadedProjectsAction,
    LoadedProjectsPagesAction,
    LoadedProjectsTotalAction,
    LoadedProjectsCurrentAction,
    LoadedProjectsLimitAction,
    LoadProjectBatchesAction,
    LoadedProjectBatchesAction,
    LoadProjectAction,
    SetProjectAction,
    CreateProjectAction,
    UpdateProjectAction,
    CreateProjectBatchAction,
    UpdateProjectBatchAction,
    DeleteProjectBatchAction,
    ScheduleProjectBatchAction
} from './react/actions/project_actions';
import {
    LoadQuestionsAction,
    LoadedQuestionsAction,
    LoadedQuestionsPagesAction,
    LoadedQuestionsTotalAction,
    LoadedQuestionsCurrentAction,
    LoadedQuestionsLimitAction
} from './react/actions/question_actions';
import {
    LoadResponsesAction,
    LoadedResponsesAction,
    CreateResponsesAction,
    LoadResponseAction,
    LoadedResponseAction
} from './react/actions/response_actions';
import {
    LoadResponsePointsAction,
    UpdateResponsePointAction,
    LoadedResponsePointsAction
} from './react/actions/response_point_actions';
import {
    LoadRolesAction,
    LoadedRolesAction,
    SyncRolesAction,
    CreateRoleAction,
    DeleteRoleAction,
    LoadPermissionsAction,
    LoadedPermissionsAction,
    UpdateRolesPermissionsAction
} from './react/actions/role_actions';
import {
    LoadRubricGroupsAction,
    LoadedRubricGroupsAction,
    LoadedRubricsPagesAction,
    LoadedRubricsTotalAction,
    LoadedRubricsCurrentAction,
    LoadedRubricsLimitAction,
    LoadRubricsAction,
    LoadedRubricsAction,
    CreateRubricAction,
    UpdateRubricAction,
    ApproveRubricsAction,
    GetRubricPDFDataAction,
    LoadRubricPDFAction
} from './react/actions/rubric_actions';
import {
    LoadSchoolsAction,
    LoadedSchoolsAction,
    LoadedSchoolsPagesAction,
    LoadedSchoolsTotalAction,
    LoadedSchoolsCurrentAction,
    LoadedSchoolsLimitAction,
    LoadSchoolAction,
    SetSchoolAction,
    CreateSchoolAction,
    UpdateSchoolAction,
    DeleteSchoolAction,
    CreateSchoolSubscriptionAction,
    DeleteSchoolSubscriptionAction,
    CheckSchoolExistsAction,
    LoadMySchoolsAction
} from './react/actions/school_actions';
import {
    LoadSettingsAction,
    LoadedSettingsAction,
    LoadedSettingsPagesAction,
    LoadedSettingsTotalAction,
    LoadedSettingsCurrentAction,
    LoadedSettingsLimitAction,
    SyncSettingsAction,
    LoadSettingAction,
    SetSettingAction,
    UpdateSettingAction
} from './react/actions/setting_actions';
import {
    LoadStandardsAction,
    LoadedStandardsAction,
    LoadedStandardsPagesAction,
    LoadedStandardsTotalAction,
    LoadedStandardsCurrentAction,
    LoadedStandardsLimitAction,
    LoadStandardAction,
    SetStandardAction,
    UpdateStandardAction,
    SyncStandardsAction
} from './react/actions/standard_actions';
import {
    LoadStreamsAction,
    LoadedStreamsAction,
    LoadedStreamsCurrentAction,
    LoadedStreamsLimitAction,
    LoadedStreamsPagesAction,
    LoadedStreamsTotalAction,
    PauseStreamAction,
    UnpauseStreamAction,
    DeleteStreamAction
} from './react/actions/stream_actions';
import {
    LoadTimespentAction,
    LoadedTimespentAction,
    LoadedTimespentPagesAction,
    LoadedTimespentTotalAction,
    LoadedTimespentCurrentAction,
    LoadedTimespentLimitAction
} from './react/actions/timespent_actions';
import {
    LoadUsersAction,
    LoadedUsersAction,
    LoadedUsersPagesAction,
    LoadedUsersTotalAction,
    LoadedUsersCurrentAction,
    LoadedUsersLimitAction,
    LoadUserAction,
    SetUserAction,
    UpdateUserAction,
    CreateUsersAction,
    ResetUserPasswordAction,
    LoadMeAction,
    LoadedMeAction,
    LoggedInAction,
    AuthCodeIssuedAction,
    RequestPasswordChangeAction,
    LoadMeSubscriptionsAction,
    LoadedMeDistrictSubscriptionAction,
    LoadedMeSchoolSubscriptionAction,
    LoadMePreferencesAction,
    LoadedMePreferencesAction,
    UpdateMePreferencesAction,
    UpdateMeAction
} from './react/actions/user_actions';

import announcement_reducers from './react/reducers/announcement_reducers';
import challenge_reducers from './react/reducers/challenge_reducers';
import contract_reducers from './react/reducers/contract_reducers';
import curriculum_reducers from './react/reducers/curriculum_reducers';
import district_reducers from './react/reducers/district_reducers';
import grading_provider_reducers from './react/reducers/grading_provider_reducers';
import lesson_reducers from './react/reducers/lesson_reducers';
import poll_reducers from './react/reducers/poll_reducers';
import project_reducers from './react/reducers/project_reducers';
import question_reducers from './react/reducers/question_reducers';
import role_reducers from './react/reducers/role_reducers';
import response_reducers from './react/reducers/response_reducers';
import response_point_reducers from './react/reducers/response_point_reducers';
import rubric_reducers from './react/reducers/rubric_reducers';
import school_reducers from './react/reducers/school_reducers';
import setting_reducers from './react/reducers/setting_reducers';
import standard_reducers from './react/reducers/standard_reducers';
import stream_reducers from './react/reducers/stream_reducers';
import timespent_reducers from './react/reducers/timespent_reducers';
import user_reducers from './react/reducers/user_reducers';
import {loading} from './react/layout/reducers';

const MindsetsJsSDK = function () {
    const auth = new Auth();
    const Api = new API(auth);

    return {
        Auth: auth,
        Api: {
            announcement: AnnouncementApi(Api),
            challengeCode: ChallengeCodeApi(Api),
            challengeLock: ChallengeLockApi(Api),
            challengeVersion: ChallengeVersionApi(Api),
            challengeEntity: ChallengeEntityApi(Api),
            curriculum: CurriculumApi(Api),
            district: DistrictApi(Api),
            lesson: LessonApi(Api),
            practice: PracticeApi(Api),
            mscs: MsCognitoServiceApi(Api),
            pam: PAMApi(Api),
            poll: PollApi(Api),
            question: QuestionApi(Api),
            rubric: RubricApi(Api),
            sam: SAMApi(Api),
            school: SchoolApi(Api),
            setting: SettingApi(Api),
            standard: StandardApi(Api),
            statistic: StatisticApi(Api),
            stream: StreamApi(Api),
            subscription: SubscriptionApi(Api),
            user: UserApi(Api),
            wowMoment: WowMomentApi(Api)
        },
        API: Api
    }
}

import * as accessConstants from "./constants/access";
import * as announcementTargetsConstants from "./constants/announcement_targets";
import * as countriesConstants from "./constants/countries";
import * as datesConstants from "./constants/dates";
import * as filterConstants from "./constants/filter";
import * as mathConstants from "./constants/math";
import * as membershipConstants from "./constants/membership";
import * as ratingsConstants from "./constants/ratings";
import * as rolesConstants from "./constants/roles";
import * as settingsConstants from "./constants/settings";
import * as statesConstants from "./constants/states";
import {SET_LIMIT_POSTFIX, SET_LIMIT_PREFIX} from "./react/components/PerPage/actions";
import {SET_CURRENT_POSTFIX, SET_CURRENT_PREFIX} from "./react/components/Paginator/actions";
import * as authUtils from "./utils/auth";
import * as contentUtils from "./utils/content";
import * as dataModelUtils from "./utils/challenge/dataModel";
import * as domUtils from "./utils/dom";
import * as ggbUtils from "./utils/ggb";
import * as immersiveReaderUtils from "./utils/immersiveReader";
import * as mathUtils from "./utils/math";
import * as metaUtils from "./utils/meta";
import * as membershipUtils from "./utils/membership";
import * as spellingUtils from "./utils/spelling";
import * as timeUtils from "./utils/time";
import * as urlUtils from "./utils/url";
import {getRowNumber} from "./react/layout/ListPage/list_page_utils";
import {catchQueryFilters} from "./react/components/Filters/filters_utils";
import * as actions from "./react/layout/actions";
import * as toastActions from "./react/components/CustomToast/actions";
import * as reducers from "./react/layout/reducers";
import toasts, * as toastReducers from "./react/components/CustomToast/reducers";

export {
    ACCESS_TOKEN_COOKIE_NAME,
    BasicLayout,
    FullLayout,
    Cookie,
    ListPage,
    Logo,
    Header,
    Footer,
    Loader,
    StackedLoader,
    LoaderMiddleware,
    LoadUpAction,
    LoadDownAction,
    LoadResetAction,
    LoadMessageAction,
    LOADUP,
    LOADDOWN,
    LOADRESET,
    LOADER_MESSAGE,
    loader,
    loader_message,
    Autocomplete,
    AutocompleteMultiple,
    Bouncing,
    ChallengeDropdown,
    ChallengeDropdownItem,
    Checkbox,
    CustomDropdown,
    CustomToast,
    DatePicker,
    DateRangeSelector,
    DistrictDropdown,
    DownloadCSV,
    ExportToGoogleDrive,
    Filters,
    HTMLContent,
    LessonDropdown,
    LessonDropdownItem,
    LinearLoader,
    MultipleSelector,
    OpenReaderSwitch,
    Paginator,
    PerPage,
    ProgressBar,
    QuickSearch,
    QuickSearchBar,
    SchoolDropdown,
    SchoolDropdownExtended,
    SchoolDropdownItem,
    SearchResult,
    Selector,
    SimplePaginator,
    Sort,
    Tabs,
    Toggle,
    UserDropdown,
    UserDropdownItem,
    accessConstants,
    announcementTargetsConstants,
    countriesConstants,
    datesConstants,
    filterConstants,
    mathConstants,
    membershipConstants,
    ratingsConstants,
    rolesConstants,
    settingsConstants,
    statesConstants,
    SET_LIMIT_POSTFIX,
    SET_LIMIT_PREFIX,
    SET_CURRENT_POSTFIX,
    SET_CURRENT_PREFIX,
    authUtils,
    contentUtils,
    dataModelUtils,
    domUtils,
    ggbUtils,
    immersiveReaderUtils,
    mathUtils,
    metaUtils,
    membershipUtils,
    spellingUtils,
    timeUtils,
    urlUtils,
    getRowNumber,
    catchQueryFilters,
    actions,
    toastActions,
    reducers,
    toastReducers,
    toasts,
    ReloadListAction,
    setLimitAction,
    setCurrentAction,
    LoadingAction,
    SuccessMessageAction,
    ErrorMessageAction,
    InfoMessageAction,
    WarningMessageAction,
    LoadAnnouncementsAction,
    LoadedAnnouncementsAction,
    LoadedAnnouncementsPagesAction,
    LoadedAnnouncementsTotalAction,
    LoadedAnnouncementsCurrentAction,
    LoadedAnnouncementsLimitAction,
    DeleteAnnouncementAction,
    MoveAnnouncementUpAction,
    MoveAnnouncementDownAction,
    LoadAnnouncementAction,
    SetAnnouncementAction,
    CreateAnnouncementAction,
    UpdateAnnouncementAction,
    LoadAnswersAction,
    LoadedAnswersAction,
    LoadedAnswersPagesAction,
    LoadedAnswersTotalAction,
    LoadedAnswersCurrentAction,
    LoadedAnswersLimitAction,
    LoadAnswerPointsAction,
    LoadedAnswerPointsAction,
    UpdateScoreAction,
    LoadChallengeCodesAction,
    LoadChallengeVersionsAction,
    LoadedChallengeVersionsAction,
    LoadedChallengeVersionsPagesAction,
    LoadedChallengeVersionsTotalAction,
    LoadedChallengeVersionsCurrentAction,
    LoadedChallengeVersionsLimitAction,
    LoadChallengeCodeAction,
    LoadedChallengeCodeAction,
    ImportChallengeAction,
    ActivateChallengeAction,
    DisableChallengeAction,
    SoftUpdateAllChallengesAction,
    SoftUpdateChallengeContentAction,
    CheckUpdatesAction,
    LoadedChallengeUpdatesAction,
    IncreaseChallengeVersionAction,
    LoadChallengeVersionAction,
    LoadedChallengeVersionAction,
    LoadedChallengeCodesAction,
    LoadChallengeResourcesAction,
    LoadedChallengeResourcesAction,
    LoadChallengeVersionStreamEntitiesAction,
    LoadedChallengeVersionStreamEntitiesAction,
    SetChallengePreviewCurrentIndexAction,
    SetChallengePreviewShowReminderAction,
    CreateDistrictChallengeLockAction,
    LoadChallengeGuideAction,
    LoadMySchoolChallengesAction,
    LoadedMySchoolChallengesAction,
    SetLibrarySubjectAction,
    SetLibraryTopicAction,
    SetLibraryGradeAction,
    SetLibraryMeasureAction,
    SetLibraryThemeAction,
    LoadContractsAction,
    LoadedContractsAction,
    LoadedContractsPagesAction,
    LoadedContractsTotalAction,
    LoadedContractsCurrentAction,
    LoadedContractsLimitAction,
    LoadContractAction,
    SetContractAction,
    CreateContractAction,
    UpdateContractAction,
    ReviewContractAction,
    ApproveContractAction,
    LoadCurriculaAction,
    LoadedCurriculaAction,
    LoadedCurriculaPagesAction,
    LoadedCurriculaTotalAction,
    LoadedCurriculaCurrentAction,
    LoadedCurriculaLimitAction,
    SyncCurriculaAction,
    LoadCurriculumAction,
    SetCurriculumAction,
    CreateCurriculumAction,
    UpdateCurriculumAction,
    LoadCurriculumByCodeAction,
    LoadCurriculumMapAction,
    LoadDistrictsAction,
    LoadedDistrictsAction,
    LoadedDistrictsPagesAction,
    LoadedDistrictsTotalAction,
    LoadedDistrictsCurrentAction,
    LoadedDistrictsLimitAction,
    DeleteDistrictAction,
    LoadDistrictAction,
    SetDistrictAction,
    CreateDistrictAction,
    UpdateDistrictAction,
    DeleteSubscriptionAction,
    CreateSubscriptionAction,
    CreateDistrictChallengeLocksAction,
    DeleteChallengeLockAction,
    LoadDistrictChallengeLocksAction,
    LoadedDistrictChallengeLocksAction,
    LoadGradingProvidersAction,
    LoadedGradingProvidersAction,
    LoadedGradingProvidersPagesAction,
    LoadedGradingProvidersTotalAction,
    LoadedGradingProvidersCurrentAction,
    LoadedGradingProvidersLimitAction,
    LoadGradingProviderAction,
    SetGradingProviderAction,
    CreateGradingProviderAction,
    UpdateGradingProviderAction,
    LoadLessonsAction,
    LoadedLessonsAction,
    LoadedLessonsPagesAction,
    LoadedLessonsTotalAction,
    LoadedLessonsCurrentAction,
    LoadedLessonsLimitAction,
    LoadLessonAction,
    SetLessonAction,
    UpdateLessonAction,
    PauseLessonAction,
    UnpauseLessonAction,
    DeleteLessonAction,
    ScheduleForScoringAction,
    AssignUsersToLessonAction,
    LoadSchedulesAction,
    LoadedSchedulesAction,
    LoadedSchedulesPagesAction,
    LoadedSchedulesTotalAction,
    LoadedSchedulesCurrentAction,
    LoadedSchedulesLimitAction,
    DeleteScheduleAction,
    VerifyScheduleAction,
    VerifyGradesAction,
    CreateSchedulesAction,
    AssignGradesAction,
    AddClassCodesToSelectionAction,
    LoadedScheduleAction,
    LoadScheduleAction,
    UpdateScheduleAction,
    JoinLessonAction,
    JoinLessonForceAction,
    LoadPDCertificateAction,
    SetTeacherFacilitationShowStudentsAction,
    SetTeacherFacilitationSortByAction,
    SetTeacherFacilitationSelectedStreamIdAction,
    SetTeacherFacilitationSelectedCardIndexAction,
    SetTeacherFacilitationQuestionFullscreenAction,
    SetTeacherFacilitationMobileShowStreamsAction,
    LoadPollByQuestionIdAction,
    SetPollAction,
    LoadPollsAction,
    LoadedPollsAction,
    LoadProjectsAction,
    LoadedProjectsAction,
    LoadedProjectsPagesAction,
    LoadedProjectsTotalAction,
    LoadedProjectsCurrentAction,
    LoadedProjectsLimitAction,
    LoadProjectBatchesAction,
    LoadedProjectBatchesAction,
    LoadProjectAction,
    SetProjectAction,
    CreateProjectAction,
    UpdateProjectAction,
    CreateProjectBatchAction,
    UpdateProjectBatchAction,
    DeleteProjectBatchAction,
    ScheduleProjectBatchAction,
    LoadQuestionsAction,
    LoadedQuestionsAction,
    LoadedQuestionsPagesAction,
    LoadedQuestionsTotalAction,
    LoadedQuestionsCurrentAction,
    LoadedQuestionsLimitAction,
    LoadResponsesAction,
    LoadedResponsesAction,
    CreateResponsesAction,
    LoadResponseAction,
    LoadedResponseAction,
    LoadResponsePointsAction,
    UpdateResponsePointAction,
    LoadedResponsePointsAction,
    LoadRolesAction,
    LoadedRolesAction,
    SyncRolesAction,
    CreateRoleAction,
    DeleteRoleAction,
    LoadPermissionsAction,
    LoadedPermissionsAction,
    UpdateRolesPermissionsAction,
    LoadRubricGroupsAction,
    LoadedRubricGroupsAction,
    LoadedRubricsPagesAction,
    LoadedRubricsTotalAction,
    LoadedRubricsCurrentAction,
    LoadedRubricsLimitAction,
    LoadRubricsAction,
    LoadedRubricsAction,
    CreateRubricAction,
    UpdateRubricAction,
    ApproveRubricsAction,
    GetRubricPDFDataAction,
    LoadRubricPDFAction,
    LoadSchoolsAction,
    LoadedSchoolsAction,
    LoadedSchoolsPagesAction,
    LoadedSchoolsTotalAction,
    LoadedSchoolsCurrentAction,
    LoadedSchoolsLimitAction,
    LoadSchoolAction,
    SetSchoolAction,
    CreateSchoolAction,
    UpdateSchoolAction,
    DeleteSchoolAction,
    CreateSchoolSubscriptionAction,
    DeleteSchoolSubscriptionAction,
    CheckSchoolExistsAction,
    LoadMySchoolsAction,
    LoadSettingsAction,
    LoadedSettingsAction,
    LoadedSettingsPagesAction,
    LoadedSettingsTotalAction,
    LoadedSettingsCurrentAction,
    LoadedSettingsLimitAction,
    SyncSettingsAction,
    LoadSettingAction,
    SetSettingAction,
    UpdateSettingAction,
    LoadStandardsAction,
    LoadedStandardsAction,
    LoadedStandardsPagesAction,
    LoadedStandardsTotalAction,
    LoadedStandardsCurrentAction,
    LoadedStandardsLimitAction,
    LoadStandardAction,
    SetStandardAction,
    UpdateStandardAction,
    SyncStandardsAction,
    LoadStreamsAction,
    LoadedStreamsAction,
    LoadedStreamsCurrentAction,
    LoadedStreamsLimitAction,
    LoadedStreamsPagesAction,
    LoadedStreamsTotalAction,
    PauseStreamAction,
    UnpauseStreamAction,
    DeleteStreamAction,
    LoadTimespentAction,
    LoadedTimespentAction,
    LoadedTimespentPagesAction,
    LoadedTimespentTotalAction,
    LoadedTimespentCurrentAction,
    LoadedTimespentLimitAction,
    LoadUsersAction,
    LoadedUsersAction,
    LoadedUsersPagesAction,
    LoadedUsersTotalAction,
    LoadedUsersCurrentAction,
    LoadedUsersLimitAction,
    LoadUserAction,
    SetUserAction,
    UpdateUserAction,
    CreateUsersAction,
    ResetUserPasswordAction,
    LoadMeAction,
    LoadedMeAction,
    LoggedInAction,
    AuthCodeIssuedAction,
    RequestPasswordChangeAction,
    LoadMeSubscriptionsAction,
    LoadedMeDistrictSubscriptionAction,
    LoadedMeSchoolSubscriptionAction,
    LoadMePreferencesAction,
    LoadedMePreferencesAction,
    UpdateMePreferencesAction,
    UpdateMeAction,
    announcement_reducers,
    challenge_reducers,
    contract_reducers,
    curriculum_reducers,
    district_reducers,
    grading_provider_reducers,
    lesson_reducers,
    poll_reducers,
    project_reducers,
    question_reducers,
    response_reducers,
    response_point_reducers,
    role_reducers,
    rubric_reducers,
    school_reducers,
    setting_reducers,
    standard_reducers,
    stream_reducers,
    timespent_reducers,
    user_reducers,
    loading
};

export default MindsetsJsSDK;
